<template>
  <div class="querybar" :class="focused ? 'bg-glass disabled' : 'normal'">
    <div class="content">
      <div class="total">
        {{ $t('components.Querybar.count', { total: total }) }}
      </div>
      <div class="action">
        <el-popover
          placement="bottom-end"
          v-model="show"
          width="281"
          trigger="manual"
          :visible-arrow="false"
          popper-class="tools-popover"
        >
          <AdvancedSearch
            :searchAction="searchAction"
            :closed="closed"
            :show="show"
            :startDate="startDate"
            :endDate="endDate"
            :type="type"
            :selectedTag="selectedTag"
            :advancedSearchQuery="advancedSearchQuery"
            ref="RefAdvancedSearch"
          >
          </AdvancedSearch>
          <span
            slot="reference"
            class="customRange"
            v-baidu-event-tracking="{ feature: '搜索结果', action: '筛选' }"
            @click="show = !show"
            >{{ $t('components.Querybar.entrance') }}</span
          >
        </el-popover>
        <span class="splitLine">|</span>
        <span
          @click="exportMemo"
          v-baidu-event-tracking="{ feature: '搜索结果', action: '导出' }"
          :class="{
            disabled: (progress > 0 && !cancelExport) || !total,
          }"
        >
          {{ $t('components.Querybar.export') }}
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import AdvancedSearchVue from './AdvancedSearch.vue'
var dayjs = require('dayjs')
import emitter from '../utils/eventbus.js'
export default {
  name: 'QueryBar',
  props: {
    searchAction: {
      type: Function,
      default: function () {},
    },
    total: {
      type: Number,
      default: 0,
    },
    closed: {
      type: Function,
      default: function () {},
    },
    show: {
      type: Boolean,
      default: false,
    },
    startDate: {
      type: String,
      default: '',
    },
    endDate: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: '',
    },
    selectedTag: {
      type: String,
      default: '',
    },
    advancedSearchQuery: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  components: {
    AdvancedSearch: AdvancedSearchVue,
  },
  data() {
    return {
      date: [],
      contain: 'all',
      other: [],
      tag: '',
    }
  },
  computed: {
    tags() {
      return this.$store.state.tags
    },
    dateOptions() {
      return {
        shortcuts: [
          {
            text: this.$t('components.Querybar.lastWeek'),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: this.$t('components.Querybar.lastMonth'),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: this.$t('components.Querybar.lastThreeMonth'),
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      }
    },
    contain0ptions() {
      return [
        {
          value: 'all',
          label: this.$t('components.Querybar.allTag'),
        },
        {
          value: 'contain',
          label: this.$t('components.Querybar.containTag'),
        },
        {
          value: 'notContain',
          label: this.$t('components.Querybar.notContainTag'),
        },
      ]
    },
    otherOptions() {
      return [
        {
          value: 'image',
          label: this.$t('components.Querybar.containImage'),
        },
        {
          value: 'link',
          label: this.$t('components.Querybar.containLink'),
        },
      ]
    },
    focused() {
      return this.$store.state.focused
    },
    progress() {
      if (this.$store.state.exportProgress == 0) {
        return 0
      }
      return ((this.$store.state.exportProgress / this.$store.state.memo_count) * 100).toFixed(2)
    },
    cancelExport() {
      return this.$store.state.cancelExport
    },
  },
  methods: {
    reset() {
      this.date = []
      this.contain = ''
      this.other = []
      this.tag = ''
    },
    search() {
      if (this.date && this.date.length) {
        this.date = [dayjs(this.date[0]).format('YYYY-MM-DD'), dayjs(this.date[1]).format('YYYY-MM-DD')]
      }
      if (
        (!this.date && this.contain == '' && !this.other && this.tag == '') ||
        (!this.date.length && this.contain == '' && !this.other.length && this.tag == '')
      ) {
        this.$message.error('请至少选择一个查询条件')
        return
      }

      this.searchAction({
        date: this.date,
        contain: this.contain,
        other: this.other,
        tag: this.tag,
      })

      this.show = false
    },
    exportMemo() {
      this.$confirm(this.$t('export.confirm.title'), this.$t('export.confirm.tip'), {
        confirmButtonText: this.$t('export.confirm.confirm'),
        cancelButtonText: this.$t('export.confirm.cancel'),
        type: 'warning',
      })
        .then(() => {
          emitter.emit('memo-export')
        })
        .catch(() => {})
    },
  },
  watch: {
    show(val) {
      if (val) {
        if (this.type) {
          this.other = this.type == 'image' || this.type == 'link' ? [this.type] : []
        } else {
          this.other = []
        }
        if (this.startDate && this.endDate) {
          this.date = [new Date(this.startDate), new Date(this.endDate)]
        } else {
          this.date = []
        }
        if (this.selectedTag) {
          this.tag = this.selectedTag
          this.contain = 'contain'
        } else {
          this.tag = ''
        }
      }
    },
  },
  created() {
    addEventListener('click', (e) => {
      if (!e.target.classList.contains('customRange')) {
        this.show = false
        // this.closed();
      }
    })
  },
}
</script>
<style scoped>
.querybar {
  padding: 0 20px;
  margin: 5px 18px 15px 15px;
}

.querybar .content {
  background: #efefef;
  border-radius: 6px;
  text-align: center;
  color: #9d9d9d;
  font-weight: 400;
  font-size: 12px;
  line-height: 17px;
  padding: 8px 0;
}

.querybar .content {
  display: flex;
  justify-content: space-between;
  background: #fafafa;
  padding: 0;
}
body.dark_mode .querybar div {
  background-color: #121212 !important;
}
.querybar .action {
  cursor: pointer;
  color: var(--tagColor);
}

.querybar-content p {
  margin-bottom: 10px;
}

.select {
  margin: 10px 0;
  display: flex;
  justify-content: space-between;
}

.btn {
  margin-top: 16px;
}
.btn span {
  border-radius: 3px;
  padding: 10px 17px;
  display: inline-block;
  font-size: 12px;
  cursor: pointer;
  color: #8f9193;
}

.btn span:first-child {
  background: #70b991;
  color: #ffffff;
}

span.disabled {
  color: lightgray;
  cursor: not-allowed;
}
span.splitLine {
  margin: 0 10px;
  margin-right: 8px;
  cursor: default;
}
</style>
<style>
body.dark_mode .el-range-input {
  background-color: #2e2e2e !important;
}
</style>
